import { render, staticRenderFns } from "./hotExhibitor.vue?vue&type=template&id=65d9e77a&scoped=true"
import script from "./hotExhibitor.vue?vue&type=script&lang=js"
export * from "./hotExhibitor.vue?vue&type=script&lang=js"
import style0 from "./hotExhibitor.vue?vue&type=style&index=0&id=65d9e77a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../../opt/deploy_node_modules/ailaworld/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65d9e77a",
  null
  
)

export default component.exports